import type { AxiosError } from "axios";

import type { IDataObjectOrTemplate, ILinkByUid } from "./types";

export class BatchOperationError extends Error {
  public errorMessages: DataObjectValidationError[];
  constructor(message: string, validation_errors: DataObjectValidationError[]) {
    super(message);
    this.errorMessages = validation_errors;
  }
}

export interface IBatchSaveRequest {
  payload: IDataObjectOrTemplate[];
  dryRun?: boolean;
}

export interface DataObjectApiError {
  code?: number;
  message?: string;
  validation_errors?: DataObjectValidationError[];
}

export interface DataObjectValidationError {
  // Name of the property in request object that failed the validation.
  property?: string;
  // Value that was provided in request object that failed the validation for given property.
  input?: string;
  // Explanation that details out why the input was considered invalid.
  failure_message?: string;
  failure_id?: string;
}

export interface BatchDeleteResponse {
  deleted_ids: string[];
  failures: BatchDeleteFailures[];
}

export interface BatchDeleteFailures {
  id: ILinkByUid;
  cause: DataObjectApiError;
}

/**
 * Checks the error response from an API call and returns an array of error messages
 * @param e the error from the server
 */
export const getErrorsFromResponse = (e: AxiosError<any>) => {
  let errors: DataObjectValidationError[] = [];
  if (e.response?.data?.validation_errors?.length > 0) {
    errors = e.response?.data.validation_errors;
  } else if (e.response?.data?.message) {
    errors = [{ failure_message: e.response.data?.message }];
  } else if (e.response?.data) {
    errors = [{ failure_message: e.response.data }];
  }
  return errors;
};
